// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-card__text[data-v-283bc434]{\n  padding: 0px 0px 64px 0px;\n}\n", ""]);
// Exports
module.exports = exports;
